import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CookieService } from './cookie.service';

@Injectable({ providedIn: 'root' })
export class GenericOldService<T> {
  apiLocation: string;

  constructor(
    private httpClient: HttpClient,
    private cookieService: CookieService,
  ) {
    this.apiLocation = this.cookieService.getCookie('markets_mock') ? 'http://wiremock:8888/v1' : '/api/v1';
  }

  private static handleError(error: string): Observable<never> {
    return throwError(() => new Error(`${error}`));
  }

  get(path: string, params?: HttpParams, mappingCallback?: (response: unknown) => T): Observable<T> {
    return this.httpClient.get<T>(`${this.apiLocation}/${path}`, { params }).pipe(
      map(item => this.mapResponse(item, mappingCallback)),
      catchError(GenericOldService.handleError),
    );
  }

  getById(
    path: string,
    id: string | number,
    params?: HttpParams,
    mappingCallback?: (response: unknown) => T,
  ): Observable<T> {
    return this.httpClient.get<T>(`${this.apiLocation}/${path}/${id}`, { params }).pipe(
      map(item => this.mapResponse(item, mappingCallback)),
      catchError(GenericOldService.handleError),
    );
  }

  getList(path: string, params?: HttpParams, mappingCallback?: (response: unknown) => T): Observable<T[]> {
    return this.httpClient.get<T[]>(`${this.apiLocation}/${path}`, { params }).pipe(
      map(items => {
        // @ts-ignore
        const data = items['data'];
        if (!mappingCallback) {
          return data as T[];
        }
        return data.map((p: unknown) => mappingCallback(p)) as T[];
      }),
      catchError(GenericOldService.handleError),
    );
  }

  add(
    path: string,
    resource: T | Partial<T>,
    params?: HttpParams,
    mappingCallback?: (response: unknown) => T,
  ): Observable<T> {
    return this.httpClient
      .post<T>(`${this.apiLocation}/${path}`, resource, {
        params,
      })
      .pipe(
        map(item => this.mapResponse(item, mappingCallback)),
        catchError(GenericOldService.handleError),
      );
  }

  update(
    path: string,
    id: string | number,
    resource?: T | Partial<T> | T[] | Partial<T>[],
    params?: HttpParams,
    mappingCallback?: (response: unknown) => T,
  ): Observable<T> {
    return this.httpClient
      .put<T>(`${this.apiLocation}/${path}/${id}`, resource, {
        params,
      })
      .pipe(
        map(item => this.mapResponse(item, mappingCallback)),
        catchError(GenericOldService.handleError),
      );
  }

  delete(
    path: string,
    id: string | number,
    params?: HttpParams,
    mappingCallback?: (response: unknown) => T,
  ): Observable<T> {
    return this.httpClient.delete<T>(`${this.apiLocation}/${path}/${id}`, { params }).pipe(
      map(item => this.mapResponse(item, mappingCallback)),
      catchError(GenericOldService.handleError),
    );
  }

  private mapResponse(item: T, mappingCallback: ((response: unknown) => T) | undefined): T {
    // @ts-ignore
    const data = item['data'];
    if (!mappingCallback) {
      if (typeof data !== 'object') {
        return data;
      }
      return data;
    }
    return mappingCallback(data);
  }
}
